module.exports = __webpack_public_path__ + "img/F5-1A.443d3151.png";